export default __webpack_public_path__ + "static/media/9-new2.9e1ea16a.png";